import React, { useState, useEffect } from 'react'
import { initPlasmicLoader, PlasmicComponent, PlasmicRootProvider } from '@plasmicapp/loader-gatsby';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import Header from '../components/Header'
import PreFooter from '../components/PreFooter'
import Footer from '../components/Footer'

export const query = graphql`
  query ($path: String) {
    plasmicComponents(componentNames: [$path])
    plasmicOptions
  }
`;

const PlasmicGatsbyPage = ({ location, data }) => {
  const { plasmicComponents, plasmicOptions } = data;
  const pageMeta = plasmicComponents.entryCompMetas[0];
  const pageMetadata = pageMeta.pageMetadata;
  const [isApp, setIsApp] = useState(false);

  useEffect(() => {
    if (window?.location) {
      let search = window.location.search
      setIsApp(search && search === '?app=true' ? true : false)

      let pathname = window.location.pathname
      if (pathname.includes('/contests')) setIsApp(true)
    }
  }, [])

  return (
    <>
      {!isApp &&
        <Header></Header>
      }
      <PlasmicRootProvider loader={initPlasmicLoader(plasmicOptions)} prefetchedData={plasmicComponents}>
        <Helmet>
          {pageMetadata.title && <title>{pageMetadata.title}</title>}
          {pageMetadata.title && <meta property="og:title" content={pageMetadata.title} />}
          {pageMetadata.description && <meta property="og:description" content={pageMetadata.description} />}
          {pageMetadata.openGraphImageUrl && <meta property="og:image" content={pageMetadata.openGraphImageUrl} />}
        </Helmet>
        <PlasmicComponent component={pageMeta.displayName} />
      </PlasmicRootProvider>
      {!isApp &&
        <>
          <PreFooter></PreFooter>
          <Footer></Footer>
        </>
      }
    </>
  );
};

export default PlasmicGatsbyPage;